import { useMemo } from "react";
import { useDebounce } from "@/hooks/use-debounce";
import useGetCataLogCode from "@/queries/catalog/use-get-catalog-code";
import { GetMedicalCodesTypeEnum } from "@/services";
import { MEDICAL_CODE_PAGE_SIZE } from "../initial-f2f-code-constant";
import { CodeItem } from "../initial-f2f-types";

export interface UseMedicalCodeOptions {
  options: CodeItem[];
  isLoading: boolean;
  setSearch: (value: string) => void;
}

/** Searches the system's medical-codes catalog; selecting a code only edits the note, nothing is saved here. */
export const useMedicalCodeOptions = (
  type: GetMedicalCodesTypeEnum,
  enabled: boolean
): UseMedicalCodeOptions => {
  const [searchKey, setSearch] = useDebounce<string>("");
  const { data, isFetching } = useGetCataLogCode({
    pagination: { page: 0, pageSize: MEDICAL_CODE_PAGE_SIZE },
    searchKey,
    type,
    active: true,
    archive: false,
    enabled,
  });

  const options = useMemo(
    () =>
      data?.data?.content?.slice(0, MEDICAL_CODE_PAGE_SIZE).map((it) => ({
        value: it.uuid ?? "",
        code: `${it.code} - ${it.description ?? ""}`,
      })) ?? [],
    [data]
  );

  return useMemo(
    () => ({ options, isLoading: isFetching, setSearch }),
    [options, isFetching, setSearch]
  );
};
